import {BREAKPOINTS} from '@constants';
import styled from 'styled-components';

export const Fullbody = styled.div`
  grid-area: fullbody / fullbleed;

  ${BREAKPOINTS.small`
    grid-area: body / fullbleed;
  `}
`;
